var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.135 1.82999L15.225 7.36499H12.99L8.625 3.38999L4.125 7.48499V14.865H7.875V16.365H3.375C3.165 16.365 2.9875 16.2925 2.8425 16.1475C2.6975 16.0025 2.625 15.825 2.625 15.615V8.86499H0.375L8.115 1.82999C8.265 1.69999 8.435 1.63499 8.625 1.63499C8.815 1.63499 8.985 1.69999 9.135 1.82999ZM10.125 8.86499H16.875V14.115H10.125V8.86499ZM11.625 10.365V12.615H15.375V10.365H11.625ZM17.625 16.365H9.375V14.865H17.625V16.365Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.9e6b0dc29809e5e4c3fb3aebfa01ac40.svg";
export { ForwardRef as ReactComponent };